import React from "react";
import * as ReactDOM from "react-dom";
import App from "./app/app";

if (window.top !== window.self) {
  (window as Window).top?.location.assign(window.location.href);
} else {
  ReactDOM.render(
    <React.Suspense fallback={null}>
      <App />
    </React.Suspense>,
    document.getElementById("root")
  );
}
